import { useQuery } from '@tanstack/react-query';
import { checklistStackApi } from '../../api/endpoints.ts';
import { useLocalizedContent } from '../../i18n/localized.ts';
import { useSession } from '../../state/session.tsx';
import { usePlanFeature } from '../plan-gate.tsx';

/**
 * The checklist templates a schedule's weekday can use, named in the reader's
 * language. Undefined until they have loaded, or where the reader cannot list
 * them, so the weekday rows simply leave the checklist picker out.
 */
export function useChecklistTemplateOptions(): Array<{ id: string; name: string }> | undefined {
  const scheduling = usePlanFeature('scheduling');
  const { can } = useSession();
  const localized = useLocalizedContent();
  const templates = useQuery({
    queryKey: ['checklist-templates'],
    queryFn: checklistStackApi.templates,
    enabled: scheduling && can('customers:read'),
  });
  return templates.data?.templates.map((template) => ({
    id: template.id,
    name: localized.text(template.definition.name, template.definition.nameTranslations),
  }));
}
